import { InstrumentType, OwnerType } from '@app/shared/models/contracts/enums/shared-enums';
import { IdentifiableInstrument } from '@app/shared/hooks/useInstrumentSort';

export const instrumentOwnersSortFn = (a: keyof typeof OwnerType, b: keyof typeof OwnerType) => {
  const ownershipOrder = Object.keys(OwnerType);

  return ownershipOrder.indexOf(a) - ownershipOrder.indexOf(b);
};

export const instrumentKeysByTypeSortFn = (
  a: keyof typeof InstrumentType,
  b: keyof typeof InstrumentType
) => {
  const instrumentOrder = Object.keys(InstrumentType);

  return instrumentOrder.indexOf(a) - instrumentOrder.indexOf(b);
};

export const sortInstrumentsByOrderIndex = (
  instrumentsMap: Record<string, { orderIndex: number }>
) => {
  return (a: IdentifiableInstrument, b: IdentifiableInstrument): number => {
    const orderA = instrumentsMap[a.instrumentId]?.orderIndex ?? 0;
    const orderB = instrumentsMap[b.instrumentId]?.orderIndex ?? 0;
    return orderA - orderB;
  };
};

export const sortByDateAsc = (a: string, b: string) =>
  new Date(a).getTime() - new Date(b).getTime();
